<script>
import { mapGetters, mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    extends: TableView,

    props: {
        boardId: {
            type: String,
            required: false,
            default: ''
        }
    },

    data() {
        return {
            includeHeader: false,
            mainClass: 'posts-table'
        };
    },

    computed: {
        ...mapGetters({
            ALL_STATUSES: 'posts/ALL_STATUSES'
        }),

        additionalFetchData() {
            return {
                boardId: this.boardId
            };
        },

        labels() {
            return [
                {
                    value: 'user.fullName',
                    sortFieldName: 'user.firstName',
                    filterFieldName: 'user.firstName',
                    text: 'Creator',
                    width: '150px'
                },
                { value: 'title', width: '200px' },
                { value: 'subtitle', width: '200px' },
                {
                    value: 'status',
                    width: '150px',
                    type: 'enum',
                    enumOptions: this.ALL_STATUSES.map(({ value }) => value)
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'posts/index',
            deleteItem: 'posts/destroy'
        }),

        onRowClick({ id, board: { id: boardId } }) {
            this.$router.push(`/boards/${boardId}/posts/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push(`/boards/${this.boardId}/posts/add`);
        },

        getRowClass({ status }) {
            return `${status}-item`;
        }
    }
};
</script>
